<!-- 弹出层 -->
<template>
    <div class="pop" v-if="popIsPop" >
      <div class="pop_mask" ></div>
      <div class="pop_panel">
          <div class="panel">
              <div class="body">
                <slot></slot>
              </div>
          </div>
      </div>
    </div>
</template>
<script>
    export default {
        name: 'pop',
        props: {
            isPop: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            popIsPop: function() {
                return this.isPop;
            }
        },
    }
</script>
<style lang="less" scoped>
    .pop_mask {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 100%;
        background: #000;
        opacity: .25;
        visibility: visible;
        z-index: 10;
        @media screen and (min-device-width: 960px) {
            margin: 0 auto;
            width: 414px;
        }
    }
    .pop_panel {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        height: auto;
        box-sizing: border-box;
        z-index: 9999;
        width: 100%;
        .panel {
            position: relative;
            // background: #fff;
            height: auto;
            margin: 0 auto;
            @media screen and (min-device-width: 960px) {
                margin: 0 auto;
                width: 414px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// pop.vue?00d6e2e6